// ResizeObserver browser quirk — harmless, suppress dev-server overlay
if (typeof window !== 'undefined') {
  window.addEventListener('error', function (e) {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
      e.stopImmediatePropagation();
    }
  });
}

// YS1: router disinda (dinamik import ile yuklenen paneller/editorler) düşen eski-chunk
// hatalarini da yakala — router.onError yalniz route gecislerini kapsar.
import { chunkHatasiMi, yeniSurumUyarisiAc } from './services/yeniSurum';
window.addEventListener('unhandledrejection', function (e) {
  if (chunkHatasiMi(e.reason)) yeniSurumUyarisiAc();
});

// IZ-J: yakalanmamış JS hataları → SetIstemciHata (chunk hatası hariç, girişliyken, imza başına 1/dk).
import { istemciHataDinleyicileriKur, istemciHataBildir } from './services/istemciHata';
istemciHataDinleyicileriKur();

// OT-3: sekmeler arası oturum eşitleme (çıkış / başka hesap / yenilenen anahtar) — storage olayı.
import { oturumSenkronBaslat } from "./services/oturumSenkron";
oturumSenkronBaslat();

import { createApp } from 'vue'
import VueApexCharts from 'vue3-apexcharts'
import App from './App.vue'
import router from './router'
import { esPublicYolMu } from './services/rotaMuafiyet'
import store from './store';
import VueAxios from 'vue-axios'
import axios from 'axios'

//import 'primevue/resources/themes/bootstrap4-light-blue/theme.css' //theme
// import 'primevue/resources/primevue.min.css' //core css
import 'primeicons/primeicons.css' //icons
import 'primeflex/primeflex.css'
import './assets/gt_style.css'
import './assets/studio-theme.css'
import './assets/sparqon-theme.css'

import './assets/tailwind.css'
import './assets/renk-semantik.css' // RN-0 (V5): .renk-* / .zemin-* / .kenar-*
import './assets/alan-boyutu.css' // AB1: html.hepy-kucuk → form alanı / düğme / tablo küçük token'ları

import { Buffer } from 'buffer';
window.Buffer = Buffer;

// RN-0: eski applyTheme kopyası kaldırıldı — tema sınıflarını yalnız services/tema.js uygular (aşağıda, mount öncesi).


const app = createApp(App);
app.config.globalProperties.$router = router;

// YS1: defineAsyncComponent (AIMessenger, GelismisEditor, ...) hatalari buraya düşer.
// console.error sart — yazilmazsa üretimde bütün Vue hatalari görünmez olur.
app.config.errorHandler = (err) => {
  if (chunkHatasiMi(err)) yeniSurumUyarisiAc();
  else istemciHataBildir(err); // IZ-J: Vue'nun yuttuğu bileşen hataları window 'error'a düşmez
  console.error(err);
};

app.config.globalProperties.session = {
    IsOnline: false,
}

// import { HelpPage } from '@/services/Helper.js'
// app.config.globalProperties.$HelpPage = HelpPage

import { Servis } from '@/services/Servis.js'
app.config.globalProperties.$Servis = Servis
window.__Servis = Servis

import { mailGecerli, telefonGecerli } from '@/utils/validation.js'
app.config.globalProperties.$mailGecerli = mailGecerli
app.config.globalProperties.$telefonGecerli = telefonGecerli

import AuthService from '@/services/auth.service.js'
// Test için window'a expose et
window.AuthService = AuthService

window.$ = window.jQuery = require('jquery');
window.JQuery = require('jquery')

var $ = window.JQuery;
window.$ = $;

import PrimeVue from 'primevue/config';

import Button from 'primevue/button';
app.component('Button', Button);

import ButtonGroup from 'primevue/buttongroup';
app.component('ButtonGroup', ButtonGroup);

import InputText from 'primevue/inputtext';
app.component('InputText', InputText);

import AutoComplete from 'primevue/autocomplete';
app.component('AutoComplete', AutoComplete);

import IconField from 'primevue/iconfield';
app.component('IconField', IconField);

import InputIcon from 'primevue/inputicon';
app.component('InputIcon', InputIcon);

import InputMask from 'primevue/inputmask';
app.component('InputMask', InputMask);

import InputNumber from 'primevue/inputnumber';
// MDK-7(a): sayı kutuları cihaz dilini izliyordu (İngilizce cihazda «2,880»). Varsayılan dil tr-TR;
// locale'i açıkça verilen kutular kendi değerini korur.
app.component('InputNumber', {
  name: 'InputNumber',
  extends: InputNumber,
  props: { locale: { type: String, default: 'tr-TR' } },
});

import Tag from 'primevue/tag';
app.component('Tag', Tag);

import Popover from 'primevue/popover';
app.component('Popover', Popover);

import Password from 'primevue/password';
app.component('Password', Password);

import Textarea from 'primevue/textarea';
app.component('Textarea', Textarea);

import Checkbox from 'primevue/checkbox';
app.component('Checkbox', Checkbox);

import Select from 'primevue/select';
app.component('Select', Select);

import SelectButton from 'primevue/selectbutton';
app.component('SelectButton', SelectButton);

import Card from 'primevue/card'
app.component('Card', Card);

import Dialog from 'primevue/dialog';
app.component('Dialog', Dialog);

import Drawer from 'primevue/drawer';
app.component('Drawer', Drawer);

import Menubar from 'primevue/menubar'
app.component('Menubar', Menubar);

import Menu from 'primevue/menu';
app.component('Menu', Menu);

import DataTable from 'primevue/datatable'
app.component('DataTable', DataTable);

import DataView from 'primevue/dataview';
app.component('DataView', DataView);

import Paginator from 'primevue/paginator';
app.component('Paginator', Paginator);

import OrderList from 'primevue/orderlist';
app.component('OrderList', OrderList);

import Column from 'primevue/column';
app.component('Column', Column);

import Row from 'primevue/row';
app.component('Row', Row);

import ColumnGroup from 'primevue/columngroup';
app.component('ColumnGroup', ColumnGroup);

import Toast from 'primevue/toast';
app.component('Toast', Toast);
import ToastService from 'primevue/toastservice';
app.use(ToastService);

import Timeline from 'primevue/timeline';
app.component('Timeline', Timeline);

import ProgressSpinner from 'primevue/progressspinner';
app.component('ProgressSpinner', ProgressSpinner);

import ConfirmPopup from 'primevue/confirmpopup';
app.component('ConfirmPopup', ConfirmPopup);

import ConfirmDialog from 'primevue/confirmdialog';
app.component('ConfirmDialog', ConfirmDialog);

import Listbox from 'primevue/listbox';
app.component('Listbox', Listbox);

import MultiSelect from 'primevue/multiselect';
app.component('MultiSelect', MultiSelect);

import Toolbar from 'primevue/toolbar';
app.component('Toolbar', Toolbar);

import RadioButton from 'primevue/radiobutton';
app.component('RadioButton', RadioButton);

import RadioButtonGroup from 'primevue/radiobuttongroup';
app.component('RadioButtonGroup', RadioButtonGroup);

import Avatar from 'primevue/avatar';
app.component('Avatar', Avatar);

import ScrollPanel from 'primevue/scrollpanel';
app.component('ScrollPanel', ScrollPanel);

import Panel from 'primevue/panel';
app.component('Panel', Panel);

import Tree from 'primevue/tree';
app.component('Tree', Tree);

import FileUpload from 'primevue/fileupload';
app.component('FileUpload', FileUpload);

import Divider from 'primevue/divider';
app.component('Divider', Divider);

import InputGroup from 'primevue/inputgroup';
app.component('InputGroup', InputGroup);

import InputGroupAddon from 'primevue/inputgroupaddon';
app.component('InputGroupAddon', InputGroupAddon);

import FloatLabel from 'primevue/floatlabel';
app.component('FloatLabel', FloatLabel);

import Tabs from 'primevue/tabs';
app.component('Tabs', Tabs);

import TabList from 'primevue/tablist';
app.component('TabList', TabList);

import Tab from 'primevue/tab';
app.component('Tab', Tab);

import TabPanels from 'primevue/tabpanels';
app.component('TabPanels', TabPanels);

import TabPanel from 'primevue/tabpanel';
app.component('TabPanel', TabPanel);

import Skeleton from 'primevue/skeleton';
app.component('Skeleton', Skeleton);

import ProgressBar from 'primevue/progressbar';
app.component('ProgressBar', ProgressBar);

import DatePicker from 'primevue/datepicker';
app.component('DatePicker', DatePicker);

import Message from 'primevue/message';
app.component('Message', Message);

import TieredMenu from 'primevue/tieredmenu';
app.component('TieredMenu', TieredMenu);

import BlockUI from 'primevue/blockui';
app.component('BlockUI', BlockUI);

import Badge from 'primevue/badge';
app.component('Badge', Badge);

import OverlayBadge from 'primevue/overlaybadge';
app.component('OverlayBadge', OverlayBadge);

import Image from 'primevue/image';
app.component('Image', Image);

import Editor from '@tinymce/tinymce-vue';
app.component('Editor', Editor);

import Chip from 'primevue/chip';
app.component('Chip', Chip);

import Breadcrumb from 'primevue/breadcrumb';
app.component('Breadcrumb', Breadcrumb);

import Fieldset from 'primevue/fieldset';
app.component('Fieldset', Fieldset);

import ToggleSwitch from 'primevue/toggleswitch';
app.component('ToggleSwitch', ToggleSwitch);

import IftaLabel from 'primevue/iftalabel';
app.component('IftaLabel', IftaLabel);

import ColorPicker from 'primevue/colorpicker';
app.component('ColorPicker', ColorPicker);

import SplitButton from 'primevue/splitbutton';
app.component('SplitButton', SplitButton);

import InputOtp from 'primevue/inputotp';
app.component('InputOtp', InputOtp);

import Stepper from 'primevue/stepper';
app.component('Stepper', Stepper);

import StepList from 'primevue/steplist';
app.component('StepList', StepList);

import StepPanels from 'primevue/steppanels';
app.component('StepPanels', StepPanels);

import StepItem from 'primevue/stepitem';
app.component('StepItem', StepItem);

import Step from 'primevue/step';
app.component('Step', Step);

import StepPanel from 'primevue/steppanel';
app.component('StepPanel', StepPanel);

 

// Türkçe lokalizasyon
const tr = {
  startsWith: 'Başlar',
  contains: 'İçerir',
  notContains: 'İçermez',
  endsWith: 'Biter',
  equals: 'Eşittir',
  notEquals: 'Eşit değildir',
  noFilter: 'Filtre yok',
  lt: 'Küçüktür',
  lte: 'Küçük veya eşittir',
  gt: 'Büyüktür',
  gte: 'Büyük veya eşittir',
  is: 'Eşittir',
  isNot: 'Eşit değildir',
  before: 'Önce',
  after: 'Sonra',
  dateIs: 'Tarih eşittir',
  dateIsNot: 'Tarih eşit değildir',
  dateBefore: 'Tarih önce',
  dateAfter: 'Tarih sonra',
  clear: 'Temizle',
  apply: 'Uygula',
  matchAll: 'Hepsini eşle',
  matchAny: 'Herhangi birini eşle',
  addRule: 'Kural Ekle',
  removeRule: 'Kuralı Kaldır',
  accept: 'Evet',
  reject: 'Hayır',
  choose: 'Seç',
  upload: 'Yükle',
  cancel: 'İptal',
  dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
  dayNamesMin: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
  monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
  monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  today: 'Bugün',
  weekHeader: 'H',
  firstDayOfWeek: 1, // Hafta Pazartesi'den başlasın (TR)
  dateFormat: 'dd.mm.yy', // GF-T11: tüm tarih kutuları tek biçim (gg.aa.yyyy)
  weak: 'Zayıf',
  medium: 'Orta',
  strong: 'Güçlü',
  passwordPrompt: 'Şifre girin',
  emptyMessage: 'Sonuç bulunamadı',
  emptyFilterMessage: 'Filtre sonucu bulunamadı',
  searchMessage: '{0} sonuç bulundu',
  selectionMessage: '{0} madde seçildi',
  emptySelectionMessage: 'Madde seçilmedi',
  showRangeEnd: 'Aralık sonunu göster',
  showRangeStart: 'Aralık başını göster',
  selectAll: 'Tümünü Seç',
  unselectAll: 'Tüm Seçimi Kaldır',
  expansionIcon: 'Genişlet',
  collapseIcon: 'Daralt',
};

// PrimeVue Localization
// import BadgeDirective from 'primevue/badgedirective';
// app.directive('Badge', BadgeDirective);


import Tooltip from 'primevue/tooltip';
app.directive('tooltip', Tooltip)

//----------------------- Custom ------------------------------------
import IslemYapiliyor from './components/HelperLayout/IslemYapiliyor.vue';
app.component('IslemYapiliyor', IslemYapiliyor);

import WaitSkeleton from './components/HelperLayout/WaitSkeleton.vue';
app.component('WaitSkeleton', WaitSkeleton);

import FormBolum from './components/HelperLayout/FormBolum.vue';
app.component('FormBolum', FormBolum);

import FormAlan from './components/HelperLayout/FormAlan.vue';
app.component('FormAlan', FormAlan);

// AY-1: form alanlarına ✨ AI metin yardımcısı — onlarca formda kullanıldığı için global.
import AiAlanYardimci from './components/HepyApp/AI/AiAlanYardimci.vue';
app.component('AiAlanYardimci', AiAlanYardimci);

import LoadingScreen from './components/HelperLayout/LoadingScreen.vue';
app.component('LoadingScreen', LoadingScreen);

import NavProgressBar from './components/HelperLayout/NavProgressBar.vue';
app.component('NavProgressBar', NavProgressBar);

import BaglantiKesintisi from './components/HelperLayout/BaglantiKesintisi.vue';
app.component('BaglantiKesintisi', BaglantiKesintisi);

import YeniSurumUyarisi from './components/HelperLayout/YeniSurumUyarisi.vue';
app.component('YeniSurumUyarisi', YeniSurumUyarisi);

import YetkiYok from './components/HelperLayout/YetkiYok.vue';
app.component('YetkiYok', YetkiYok);

import SayfaBasligi from './components/HelperLayout/SayfaBasligi.vue';
app.component('SayfaBasligi', SayfaBasligi);
import YeniDugme from './components/HelperLayout/YeniDugme.vue'; // MD-3: liste sayfalarının «Yeni» düğmesi dar ekranda FAB
app.component('YeniDugme', YeniDugme);
import FiltrePaneli from './components/HelperLayout/FiltrePaneli.vue'; // MD-4: rapor filtreleri dar ekranda Dönem çipi + Filtre paneli
app.component('FiltrePaneli', FiltrePaneli);
import KartListesi from './components/HelperLayout/KartListesi.vue'; // MDK-6: ortak tabloyu kullanmayan listelerin dar ekran kart görünümü
app.component('KartListesi', KartListesi);

import StudioAvatar from './components/HelperLayout/StudioAvatar.vue';
app.component('StudioAvatar', StudioAvatar);

import DualList from './components/Reusable/DualList.vue';
app.component('DualList', DualList);

import TelefonGirisi from './components/Reusable/TelefonGirisi.vue';
app.component('TelefonGirisi', TelefonGirisi);

// ADR: Leaflet ana paketi sismesin diye ayri chunk (yalniz adres formu acilinca yuklenir)
import { defineAsyncComponent as _adresAsync } from 'vue';
app.component('AdresAlani', _adresAsync(() => import(/* webpackChunkName: "adres-alani" */ './components/Reusable/AdresAlani.vue')));


// -------------------------------------------------
import VueScrollTo from 'vue-scrollto';
app.use(VueScrollTo);


 import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { temaUygula, temaSiniflariniUygula, kayitliTema } from './services/tema';
import { boyutUygula, normalZorla, kayitliBoyut } from './services/alanBoyutu';

// RN-0 (RENK-SAKINLESTIRME-PLANI.md V1): dolu düğme açıkta 700 / koyuda 600 tonu + beyaz yazı
// (Aura: açıkta 500, koyuda 400 + koyu yazı — koyuda zemine 9-11 kontrastla "patlıyordu").
// Üzerine gelince açıkta 800, koyuda 500. Çerçeveli / metin düğme yazısı açıkta 700, koyuda 400.
// tailwind.css'teki açık tema --p-button-* düzeltmesi (2026-09-24) buraya taşındı.
const RN_SEVERITY = { success: 'green', info: 'sky', warn: 'orange', help: 'purple', danger: 'red' };
function rnDugmeTokenlari(koyu) {
    const root = {}, outlined = {}, text = {};
    const dolu = koyu ? 600 : 700, ustunde = koyu ? 500 : 800, basili = koyu ? 700 : 900, yazi = koyu ? 400 : 700;
    Object.entries(RN_SEVERITY).forEach(([sev, r]) => {
        root[sev] = {
            background: `{${r}.${dolu}}`, hoverBackground: `{${r}.${ustunde}}`, activeBackground: `{${r}.${basili}}`,
            borderColor: `{${r}.${dolu}}`, hoverBorderColor: `{${r}.${ustunde}}`, activeBorderColor: `{${r}.${basili}}`,
            color: '#ffffff', hoverColor: '#ffffff', activeColor: '#ffffff',
            focusRing: { color: `{${r}.${dolu}}` },
        };
        outlined[sev] = koyu ? { color: `{${r}.${yazi}}` } : { color: `{${r}.${yazi}}`, borderColor: `{${r}.300}` };
        text[sev] = { color: `{${r}.${yazi}}` };
    });
    outlined.primary = koyu ? { color: '{emerald.400}' } : { color: '{emerald.700}', borderColor: '{emerald.300}' };
    text.primary = { color: koyu ? '{emerald.400}' : '{emerald.700}' };
    return { root, outlined, text };
}

// KT1: koyu temada Aura'nın zinc yüzeyleri yerine tek palet — Tailwind gray. Açık tema aynı kalır.
const HepyAura = definePreset(Aura, {
    components: {
        button: { colorScheme: { light: rnDugmeTokenlari(false), dark: rnDugmeTokenlari(true) } },
        // RN-0 (K4): kart = ince kenar (gt_style.css .p-card) + shadow-sm; gölge yalnız overlay'de.
        card: { root: { borderRadius: '12px', shadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' } },
    },
    semantic: {
        colorScheme: {
            light: {
                primary: { color: '{emerald.700}', contrastColor: '#ffffff', hoverColor: '{emerald.800}', activeColor: '{emerald.900}' },
            },
            dark: {
                primary: { color: '{emerald.600}', contrastColor: '#ffffff', hoverColor: '{emerald.500}', activeColor: '{emerald.700}' },
                surface: {
                    0: '#ffffff', 50: '{gray.50}', 100: '{gray.100}', 200: '{gray.200}', 300: '{gray.300}',
                    400: '{gray.400}', 500: '{gray.500}', 600: '{gray.600}', 700: '{gray.700}',
                    800: '{gray.800}', 900: '{gray.900}', 950: '{gray.950}',
                },
            },
        },
    },
});

 //- ------------------------------------------------
// // Tema
// const darkModeMedia = window.matchMedia('(prefers-color-scheme: dark)');

// function updateTheme(e) {
//   document.documentElement.classList.remove('light-theme', 'dark-theme');
//   document.documentElement.classList.add(e.matches ? 'dark-theme' : 'light-theme');
// }
// darkModeMedia.addEventListener('change', updateTheme); // Canlı takip
// updateTheme(darkModeMedia); // Başlangıçta da uygula

// Tema (preset + renk + açık/koyu) tema.js servisi tarafından yönetilir.
// Kaydedilmiş tema app.use(PrimeVue) sonrasında uygulanır (aşağıda).

// import Nora from '@primeuix/themes/nora';
// import Lara from '@primeuix/themes/lara';
// import Material from '@primeuix/themes/material';

app.use(PrimeVue,
    {
        locale: tr,
        theme:
        {
            preset: HepyAura,
             options: {
                 darkModeSelector: '.my-app-dark',
             }
        },
    },


);

// Kaydedilmiş temayı (localStorage) hemen uygula — flash olmasın. KT0: açılış URL'i public ise
// (kayıtlı tema koyu olsa bile) kaydetmeden açık uygula — router guard'ı beklemeden önce
// public sayfada koyu flaşı önler (KOYU-TEMA-PLANI.md §4-3).
if (esPublicYolMu(window.location.pathname.toLowerCase(), window.location.href)) {
  temaSiniflariniUygula(false);
  normalZorla(); // AB1: dışarı açık sayfa her zaman normal
} else {
  temaUygula(kayitliTema());
  boyutUygula(kayitliBoyut());
}

app.use(router);
app.use(store);
app.use(VueAxios, axios);

import ConfirmationService from 'primevue/confirmationservice';
app.use(ConfirmationService);
// LAO2 (B-43): stil vermeyen onay pencerelerinde Vazgeç çerçeveli ikincil düğme (tek dolu düğme).
// Düğme metni rejectLabel'dan okunmaya devam eder (PrimeVue 5.0.0 ConfirmDialog).
{
  const confirmRequire = app.config.globalProperties.$confirm.require;
  app.config.globalProperties.$confirm.require = (secenek) => {
    if (secenek && !secenek.rejectClass && !secenek.rejectProps) {
      secenek = { ...secenek, rejectProps: { severity: "secondary", outlined: true } };
    }
    return confirmRequire(secenek);
  };
}

app.use(VueApexCharts);

app.mount('#app');

// ------------------------------------------------------------------
// Capacitor native davranışları (Faz M0) — yalnız gerçek cihazda/emülatörde çalışır
// (Capacitor.isNativePlatform() false ise web tarayıcısında hiçbir şey yapılmaz).
// bkz. Dokumanlar/MobilProjesi/MOBIL-CAPACITOR-PLAN.md §1.4.
import { Capacitor } from '@capacitor/core';

if (Capacitor.isNativePlatform()) {
  // MOB M2-a: indirme / PDF / yeni sekme / yazdır → dosya paylaş + sistem tarayıcısı (services/yerelDosya).
  import('./services/yerelDosya').then(({ yerelDosyaKur }) => yerelDosyaKur());

  // MOB M1-4: uygulamaya özel CSS (gt_style.css .yerel-uygulama …) — ör. diyaloglar en çok 95vw.
  document.documentElement.classList.add('yerel-uygulama');

  import('@capacitor/app').then(({ App: CapApp }) => {
    CapApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) router.back();
      else CapApp.exitApp();
    });
  });

  // MOB M1-0: durum çubuğu tema değişimini izler (tek kaynak uiState.koyuTema — services/tema).
  // Style.Dark = açık renkli simgeler (koyu zemin için).
  Promise.all([import('@capacitor/status-bar'), import('vue'), import('./services/uiState')]).then(([{ StatusBar, Style }, { watch }, { uiState }]) => {
    const uygula = (koyu) => StatusBar.setStyle({ style: koyu ? Style.Dark : Style.Light }).catch(() => {});
    uygula(uiState.koyuTema ?? initialTheme === 'dark');
    watch(() => uiState.koyuTema, uygula);
  });

  // MOB M1-1: canlı güncelleme (panel.hepy.app/mobil/surum.txt) + "hazırım" bildirimi.
  import('./services/mobilGuncelleme').then(({ mobilGuncellemeBaslat }) => mobilGuncellemeBaslat(router));

  // MOB M2-b: push bildirimi — girişte cihaz kaydı, dokununca ilgili kayıt (services/mobilPush).
  import('./services/mobilPush').then(({ mobilPushBaslat }) => mobilPushBaslat(router));

  import('@capacitor/splash-screen').then(({ SplashScreen }) => {
    SplashScreen.hide().catch(() => {});
  });

  // MOB M1-0: setResizeMode yalnız iOS'ta var (Android'de UNIMPLEMENTED — orada windowSoftInputMode yeter).
  if (Capacitor.getPlatform() === 'ios') import('@capacitor/keyboard').then(({ Keyboard }) => {
    Keyboard.setResizeMode({ mode: 'body' }).catch(() => {});
  });
}

// Dış linkleri (Gizlilik Politikası vb.) native'de sistem tarayıcısında açmak için ortak yardımcı —
// ekran ekran linklerin buna geçirilmesi ayrı bir iş (Faz M1), burada yalnız altyapı hazırlanıyor.
app.config.globalProperties.$disLinkAc = function (url) {
  if (Capacitor.isNativePlatform()) {
    import('@capacitor/browser').then(({ Browser }) => Browser.open({ url }));
  } else {
    window.open(url, '_blank');
  }
};